import { addNamespaceInOperations } from '../helper'

export const GETTERS_METHODS = {
  GET_FILTERS: 'getFilters'
}

export const getters = {
  [GETTERS_METHODS.GET_FILTERS]: (state) => (filter = []) => {
    const filters = state.filters
    if (!filter.length) return filters
    return filters.filter(f => filter.indexOf(f.idElement) > -1)
  }
}

export const GETTERS = addNamespaceInOperations('plaka', GETTERS_METHODS)
